import { ValidationService } from '../services/validation.service';

export class FisheryNotice {

    subject: string = ''; // the email subject

    bodyHTML: string = ''; // the email body

    receivedTime: Date = new Date(); // the date and time the email was received

    noticeNumber: string = ''; // the fishery notice number (parsed out of the email)

    //deletionDate = new Date(); // the date on which the notice should be deleted (not used atm)

    /* Categories */

    gillNet: boolean = false;

    seine: boolean = false;

    troll: boolean = false;

    /* Notice Metadata */

    isSaved: boolean = false;

    isRead: boolean = false;

    constructor(subject: string = '', body: string = '', date: Date = new Date(), number: string = '') {
        this.subject = subject;
        this.bodyHTML = body;
        this.receivedTime = date;
        this.noticeNumber = number;
    }

    // NOT NEEDED RIGHT NOW BUT WILL KEEP FOR LATER:
    // returns the deletion date for the notice (for auto-deletion)
    // public static getDeletionDate(date: Date, categories: string[]): Date {

    //   let deletionDate: Date = new Date(date);

    //   if (categories.includes('Troll')) {
    //     deletionDate.setMonth(deletionDate.getMonth() + 2); // increment received date by 2 months
    //   }

    //   else if (categories.includes('Gill Net') || categories.includes('Seine')) {
    //     deletionDate.setDate(deletionDate.getDate() + 14); // increment the received date by 2 weeks
    //   }

    //   // if the notice does not fit into any of the above categories, increment the received date by 3 months
    //   else {
    //     deletionDate.setMonth(deletionDate.getMonth() + 3); // VERIFY WITH MATT HOW LONG WE SHOLD KEEP THESE
    //   }

    //   return deletionDate;
    // }

    public static transformAnonArray(notices: any[]): FisheryNotice[] {

        let noticeArray: FisheryNotice[] = [];

        for (let notice of notices) {
            noticeArray.push(this.transformAnonymous(notice));
        }

        return noticeArray;

    }

    public static transformAnonymous(notice: any): FisheryNotice {

        let newNotice: FisheryNotice = new FisheryNotice(
            notice.subject ?? '',
            notice.bodyHTML ?? '',
            ValidationService.validateDate(notice.receivedTime),
            notice.noticeNumber ?? ''
        );

        newNotice.gillNet = notice.gillNet ?? false;
        newNotice.seine = notice.seine ?? false;
        newNotice.troll = notice.troll ?? false;
        newNotice.isSaved = notice.isSaved ?? false;
        newNotice.isRead = notice.isRead ?? false;
       // newNotice.deletionDate = this.getDeletionDate(newNotice.date, newNotice.categories);

        return newNotice;

    }

}
